import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Select, Button, Input, Collapse, Table, Icon, Modal } from 'antd';

const Option = Select.Option;

class EditForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      defaultEmail: this.props.email || '',
      defaultRole: this.props.role || 'Collaborator',
      nameError: false,
    };
  }

  updateUserAtt(e) {
    var newValues = {};
    if (e.target && e.target.name == 'email') {
      newValues.email = e.target.value;
    }
    if (typeof e == 'string') {
      newValues.role = e;
    }
    if (e.target && e.target.name == 'name') {
    }

    this.props.sendToParent(newValues);
  }

  componentWillReceiveProps(nextProps) {
    var defaultEmail = nextProps.email == null ? '' : nextProps.email;
    var defaultRole = nextProps.role == '' ? 'Collaborator' : nextProps.role;
  }

  render() {
    var isCreateModal = this.props.type == 'Create';
    var valueProperty = isCreateModal ? null : this.props.name;
    var defaultRole = this.props.role == 'Administrator' ? this.props.role : 'Collaborator';
    var defaultEmail = this.props.email;
    return (
      <div>
        <Input
          name='email'
          placeholder='Email Required For Filters'
          value={defaultEmail}
          onChange={this.updateUserAtt.bind(this)}
          style={{ marginBottom: 16 }}
        />
        <Select
          name='role'
          value={defaultRole}
          className='editUserSelect'
          onChange={this.updateUserAtt.bind(this)}
          style={{ marginBottom: 16, width: '100%' }}>
          <Option value='Collaborator'>Collaborator</Option>
          <Option value='Administrator'>Administrator</Option>
        </Select>
      </div>
    );
  }
}

export default EditForm;



// WEBPACK FOOTER //
// ./src/components/superUser/EditForm.js